import { render, staticRenderFns } from "./generalComponent.vue?vue&type=template&id=22ffb98c&scoped=true&"
import script from "./generalComponent.vue?vue&type=script&lang=js&"
export * from "./generalComponent.vue?vue&type=script&lang=js&"
import style0 from "./generalComponent.vue?vue&type=style&index=0&id=22ffb98c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffb98c",
  null
  
)

export default component.exports